<template>
    <div class="pageClass VideoOverview">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        
        <div class="d-flex flex-column overviewBtn" @click="OpenOverview(1)" data-toggle="modal" data-target="#exampleModalLong" >
            <font-awesome-icon icon="fa-solid fa-eye" size="3x" />
            <span class="mx-auto">{{ $t('videoOverview.overview') }}</span>
        </div>

            <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{ $t('videoOverview.aboutThisCourse') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="MaterialItem in Material" class="">
                            <h6 class="MaterialTitle">{{MaterialItem.MaterialName}}</h6>
                            <hr>
                            <div v-for="item in MaterialItem.UnitData">
                            
                                <div class="d-flex align-items-center">
                                    <font-awesome-icon icon="fa-solid fa-circle" />
                                    <h5 class="ml-2">{{item.Unit}}. {{item.Name}}</h5>
                                </div>
                                <span style="white-space: pre-line;" v-html="item.Content">{{}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'VideoOverview',
    props: ['CourseId'],
    components:{
    },
    data () {
        return {
            loginInputData:{
                Token :'',
                CustomerCode:'',
                StudentId:''
            },
            showLoading:false,
            Material:[],
        }
    },
    methods:{
        OpenOverview(type){ //0:computer 1:phone showModal
            if(type == 0){
                this.ShowMaterial=!this.ShowMaterial;
            }
            this.GetVideoClassIntroductionByCourseId();
        },
        //取得所有課程單元簡介
        GetVideoClassIntroductionByCourseId(){
            this.showLoading = true;
            const api =`${process.env.VIDEOAPIPATH}/api/Material/GetVideoClassIntroductionByCourseId`;
            const headers = {"Authorization": 'Bearer '+this.loginInputData.Token};
            const inputdata = 
            {
                "CourseId": this.CourseId,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.IsSuccess){
                        this.Material = response.data.Material;
                    }else{
                        
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },    
    created(){
        this.loginInputData.Token = sessionStorage.getItem('Token');
        this.loginInputData.StudentId = sessionStorage.getItem('StudentId');
        this.$root.$refs.VideoOverview = this;
    }
}
</script>





// WEBPACK FOOTER //
// src/components/VideoPage/VideoOverview.vue